<template>
  <div v-if="isShow" class="loading">
    <div class="loading-m">
      <img src="https://resource.rcclchina.com.cn/Home/mb_loading.gif" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      isShow: false,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10600;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  .loading-m {
    position: absolute;
    left: 50%;
    top: 50%;
    padding: 0px;
    background: transparent;
    width: 90px;
    height: 90px;
    border-radius: 12px;
    overflow: hidden;
    line-height: initial;
    margin-left: -45px;
    margin-top: -45px;
    z-index: 11000;
    img {
      width: 100%;
    }
  }
}

</style>
